// Puerto Rico cities in alphabetical order
export const PUERTO_RICO_CITIES = [
  'Adjuntas',
  'Aguada',
  'Aguadilla',
  'Aguas Buenas',
  'Aibonito',
  'Añasco',
  'Arecibo',
  'Arroyo',
  'Barceloneta',
  'Barranquitas',
  'Bayamón',
  'Cabo Rojo',
  'Caguas',
  'Camuy',
  'Canóvanas',
  'Carolina',
  'Cataño',
  'Cayey',
  'Ceiba',
  'Ciales',
  'Cidra',
  'Coamo',
  'Comerío',
  'Corozal',
  'Culebra',
  'Dorado',
  'Fajardo',
  'Florida',
  'Guánica',
  'Guayama',
  'Guayanilla',
  'Guaynabo',
  'Gurabo',
  'Hatillo',
  'Hormigueros',
  'Humacao',
  'Isabela',
  'Jayuya',
  'Juana Díaz',
  'Juncos',
  'Lajas',
  'Lares',
  'Las Marías',
  'Las Piedras',
  'Loíza',
  'Luquillo',
  'Manatí',
  'Maricao',
  'Maunabo',
  'Mayagüez',
  'Moca',
  'Morovis',
  'Naguabo',
  'Naranjito',
  'Orocovis',
  'Patillas',
  'Peñuelas',
  'Ponce',
  'Quebradillas',
  'Rincón',
  'Río Grande',
  'Sabana Grande',
  'Salinas',
  'San Germán',
  'San Juan',
  'San Lorenzo',
  'San Sebastián',
  'Santa Isabel',
  'Toa Alta',
  'Toa Baja',
  'Trujillo Alto',
  'Utuado',
  'Vega Alta',
  'Vega Baja',
  'Vieques',
  'Villalba',
  'Yabucoa',
  'Yauco'
];

// Homepage video background URL
export const HOMEPAGE_VIDEO_URL = 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2FAlicea%20Realty%20%231.mp4?alt=media&token=5e56ebf1-d586-4446-a121-63d013382d4d';

// Certifications data - can be easily modified to add/remove certifications
export const CERTIFICATIONS = [
  { id: 1, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fe-pro.png?alt=media&token=bcd77cd6-0870-487f-b6fc-eeaa2f1d176c', alt: 'Certification Logo 1' },
  { id: 2, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fabr.jpg?alt=media&token=3bdda988-8281-46be-89a6-e0f5a4690442', alt: 'Certification Logo 2' },
  { id: 3, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fgreen.png?alt=media&token=99ee7372-ecaa-4201-a7d8-4a046ac92eaa', alt: 'Certification Logo 3' },
  { id: 4, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fsfr.jpg?alt=media&token=a07237be-e79f-4442-aaf9-15d384633407', alt: 'Certification Logo 4' },
  { id: 5, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Frene.png?alt=media&token=61782c67-2d03-45f6-aafe-59de54984056', alt: 'Certification Logo 5' },
  { id: 6, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fpsa.png?alt=media&token=09eb0032-7ba2-48c2-b308-d4c0ea64eda4', alt: 'Certification Logo 6' },
  { id: 7, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fc2ex.png?alt=media&token=3c37b4df-5903-466e-a991-3941f1c2838e', alt: 'Certification Logo 7' },
  { id: 8, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fahwd.png?alt=media&token=7c164962-f1af-4132-8239-2859230980fa', alt: 'Certification Logo 8' },
  { id: 9, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Flead.JPG?alt=media&token=e9b468d1-2c3e-48a5-82d2-9df38404cace', alt: 'Certification Logo 9' },
  { id: 10, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Ffairhaven.png?alt=media&token=57c4b4f1-59e0-49aa-b61a-18a39fb2c103', alt: 'Certification Logo 10' },
  { id: 11, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fpac.jpg?alt=media&token=96d94ac5-6afe-482f-9f2e-fb7b1d78645f', alt: 'Certification Logo 11' },
];

// Memberships data - add membership logos/entries here
export const MEMBERSHIPS = [
  { id: 1, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fnar.png?alt=media&token=31558874-cb98-4624-8cb4-46e44183a68f', alt: 'National Association of REALTORS (NAR)' },
  { id: 2, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fprar.jpg?alt=media&token=9ac81260-9598-412a-987c-7d480b57a20f', alt: 'Puerto Rico Association of REALTORS (PRAR)' },
  { id: 3, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fmidisland.png?alt=media&token=b0ec7046-29ce-45e0-886a-0be5291613f1', alt: 'Mid Island Association of REALTORS (MIAR)' },
  { id: 4, src: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fxposure.png?alt=media&token=ef586d84-f0ae-451e-be46-919d24d1208e', alt: 'XPOSURE MLS' },
];
